const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },    
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },    
    {
        prop: 'NMunicipio',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'NroTiket',
        label: 'Nro. Ticket',
        minWidth: 150
    },
    {
        prop: 'Origen',
        label: 'Origen',
        minWidth: 100
    },    
    {
        prop: 'TipoEvento',
        label: 'Tipo',
        minWidth: 150
    },
    {
        prop: 'FechaEvent',
        label: 'Fecha',
        minWidth: 150
    },
    {
        prop: 'IDPunto',
        label: 'ID Punto',
        minWidth: 150
    },
    {
        prop: 'Cedula',
        label: 'Cédula',
        minWidth: 150
    }
]

const table_plus = [
    {
        prop: 'Region',
        label: 'Región',
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
    },
    {
        prop: 'NMunicipio',
        label: 'Municipio',
    },         
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
    },    
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
    },   
    {
        prop: 'NroTiket',
        label: 'Nro. Ticket',
    },    
    {
        prop: 'Origen',
        label: 'Origen',
    },    
    {
        prop: "Prioridad",
        label: "Prioridad", 
    },    
    {
        prop: 'TipoEvento',
        label: 'Tipo',
    },    
    {
        prop: "Encargado",
        label: "Encargado", 
    },
    {
        prop: "Solicitante",
        label: "Solicitante", 
    },    
    {
        prop: 'IDPunto',
        label: 'ID Punto',
    },    
    {
        prop: 'Cedula',
        label: 'Cédula',
    },    
    {
        prop: "Barrio",
        label: "Barrio", 
    }, 
    {
        prop: "Dirección",
        label: "Dirección", 
    },  
    {
        prop: "Telefono",
        label: "Telefono", 
    }, 
    {
        prop: "Email",
        label: "Email", 
    },
    {
        prop: "FechaReport",
        label: "Fecha Repore", 
    },    
    {
        prop: 'FechaEvent',
        label: 'Fecha',
    },    
    {
        prop: "EstadoReporte",
        label: "Estado Repore", 
    },
    {
        prop: "celular",
        label: "Celular", 
    }, 
    {
        prop: "direccion",
        label: "Direccion", 
    },  
    {
        prop: "Mail",
        label: "Mail", 
    }, 
    {
        prop: "Name",
        label: "Name", 
    },      
    {
        prop: "HoraInicio",
        label: "Hora Inicio", 
    },
    {
        prop: "FecCierre",
        label: "Fecha de Cierre", 
    },  
    {
        prop: "HoraFin",
        label: "Hora Fin", 
    },
    {
        prop: "FechaLimiteCierre",
        label: "Fecha Limite de Cierre", 
    },
    {
        prop: "FechaCierre",
        label: "Fecha de Cierre", 
    },     
    {
        prop: "Descripcion",
        label: "Descripción", 
    },
    {
        prop: "CantAccesos",
        label: "Cant. Accesos", 
    },
    {
        prop: "nroDocum",
        label: "Nro. Documento", 
    },
    {
        prop: "Coordenadas",
        label: "Coordenadas", 
    },
    {
        prop: "DescripcionST",
        label: "DescripcionST", 
    },
  
]

export default [table, table_plus]
